import type { FC } from "react";
import { IconProps } from "./types";

export const SidebarFilled: FC<IconProps> = ({ size = "1em", ...props }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...props}>
    <path
      d="M19 2.25C20.5188 2.25 21.75 3.48122 21.75 5V19C21.75 20.5188 20.5188 21.75 19 21.75H5C3.48122 21.75 2.25 20.5188 2.25 19V5C2.25 3.48122 3.48122 2.25 5 2.25H19ZM9.75 20.25H19C19.6904 20.25 20.25 19.6904 20.25 19V5C20.25 4.30964 19.6904 3.75 19 3.75H9.75V20.25Z"
      fill="currentColor"
    />
  </svg>
);
